import { t as __t } from "i18next";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { callGetExportAgent } from "../../../api/callcenters/service"
import { callExportAgent, callExportClame, callExportClameExcel, callExportClameSummaryExcel, getExportClameSummary } from "../../../api/export"
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import RecordsTableFilter from "../../../components/table-filter"
import "../../../components/i18n/lang";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../components/paginations";
import moment from "moment";
import Swal from "sweetalert2";
import reports from '../../../data/reportAgent'
import { callGetAllProvince } from "../../../api/settings/service";
import DatePicker from "react-datepicker";
import { dateToString, FormatCurrencys } from "../../../utils/commonUtil";
import SmartTable from "../../../components/common/table-component";
const Index = () => {

	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [request, setRequest] = useState({ page: 1, maxResult: 10, keyword: '', reportType: 1, startDate: '', endDate: '', year: '2025' });
	const [dataList, setDataList] = useState([]);
	const [columns, setColumns] = useState([

	]);
	useEffect(() => {
		setColumns([
			{
				label: request.reportType == 1 ? 'clameContractProvinceName' : request.reportType == 2 ? "clameContractMonth" : request.reportType == 3 ? "clameContractRegion" : 'clameContractByAgentCode', key: request.reportType == 1 ? 'provinceName' : request.reportType == 2 ? 'month' : request.reportType == 3 ? "region" : 'agentCode', style: { minWidth: '200px' }, render: (val, item) => (
					val ? request.reportType == 3 ? t('report.customer.region.' + val) : request.reportType == 4 ? (item.agentCode + ' ' + item.agentName) : val : 0
				)
			},
			{
				label: 'clameContractGty', style: { minWidth: '50px' }, key: 'qty', render: (val) => (
					val ? val : 0
				)
			}, {
				label: "clameTotalAmountClaim", style: { minWidth: '100px' }, key: 'totalAmountClaim', render: (val) => (
					FormatCurrencys(val)
				)
			}
		])
		loadData();
	}, [request]);

	const loadData = async (e) => {
		let data = { ...request }
		if (e) {
			data = { ...e }
		}
		const rsp = await dispatch(getExportClameSummary(data));
		if (rsp?.payload?.responseCode === "00000") {
			console.log(rsp.payload.data)
			setDataList(rsp.payload.data);
		}
	};
	const handleChange = (e) => {
		const { name, value } = e.target;
		setRequest((prev) => ({ ...prev, [name]: value }));
	};


	const onSearch = async (e) => {
		e.preventDefault()
		loadData()
	}

	const selectReportType = (e) => {
		setRequest((prev) => ({
			...prev,
			reportType: e.target.value,
		}));
	}


	const downloadExcel = async () => {
		try {
			let data = { ...request,maxResult: this.dataList.totalRecords }
			let response = await callExportClameSummaryExcel(data);
			if (response === null) {
				Swal.fire(__t("uiText.text023"), __t("uiText.text025"), "error");
				return
			}
			const url = URL.createObjectURL(response);
			const link = document.createElement("a");
			link.href = url;
			link.download = __t("uiText.text330", { value1: moment().format("YYYYMMDDHHmmss") });
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} catch (error) {
			console.error("❌ Error downloading Excel:", error);
		}
	};

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<section className="user-dashboard">
				<div className="dashboard-outer">
					<div className="upper-title-box">
						<h4>{t("menu.report.vehicleReportClaimSummary")}</h4>

						<div className="group-button-header">
							<button className="btn btn-success" onClick={downloadExcel}>
								<i className="fas fa-file-export"></i> {t("button.exportExcel")}
							</button>
						</div>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<div className="default-form">
											<div className="row">
												<div className="col-md-2 form-group">
													<label>{t('startDate')}</label>
													<DatePicker
														selected={request.year}
														onChange={date => setRequest((prev) => ({
															...prev,
															year: moment(date).format('YYYY-MM-DD'),
														}))}
														showYearPicker={true}
														dateFormat="yyyy"
														placeholderText={t('startDate')}
														className="form-control-uld"
													/>
												</div>
												<div className="col-md-3 form-group">
													<label>{t('report.customer.reportTypeName')}</label>
													<select className="chosen-single form-select"
														onChange={selectReportType}
														value={request.reportType}
													>
														{
															reports.reportTypeInsuranClame.map((item) => (
																<option key={item.id} value={item.id}>{t(item.name)}</option>
															))
														}
													</select>
												</div>
												<div className="col-auto auto-button">
													<label style={{ marginTop: 6 }}>&nbsp;</label>
													<button className="theme-btn btn-style-one w-100" onClick={onSearch}>
														<i className="fas fa-search"></i>&nbsp;{t("button.search")}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>


					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<SmartTable columns={columns} data={dataList} keyword={request.keyword} onLazyLoad={loadData}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<CopyrightFooter />
		</div>
	);
};

export default Index;
